import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';

const  baseRef = 'situacao-entidade';
const route = {
  listar: `${baseRef}/combo`,
}

@Injectable({
  providedIn: 'root'
})
export class SituacaoEntidadeService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listar() {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any[]>(route.listar, undefined, undefined, true)
    );
  }
}
